import React, { useState } from "react";
import { Grid, Typography, Button} from "@material-ui/core";
import useStyles from "components/Home/Styles";
import homeActions from "./actions";

const AboutSection = () => {
  const classes = useStyles();
  const { getMethodologyPDF } = homeActions();

  const [disabledDownload, setDisabledDownload] = useState(false)

  return (
    <Grid container item className={classes.aboutContainer}>
      <Grid item xs={12} lg={4} className={classes.sectionContainer}>
        <Typography
          component="div"
          variant="h6"
          className={classes.sectionTitle}
        >
          What is the CuRVE?
        </Typography>
        <Typography
          component="div"
          variant="body2"
          className={classes.sectionDescription}
        >
          The CuRVE visualizes potential local impacts of Colorado River
          shortages for individual community water systems, agricultural
          districts, tribal communities and industries across multiple years.
        </Typography>
        {/* <Button variant="text" className={classes.learnMore} endIcon={<ArrowForwardIcon className={classes.nextButton}/>}>LEARN MORE </Button> */}
      </Grid>
      <Grid item xs={12} lg={4} className={classes.sectionContainer}>
        <Typography
          component="div"
          variant="h6"
          className={classes.sectionTitle}
        >
          {"Current & Future Plans"}
        </Typography>
        <Typography
          component="div"
          variant="body2"
          className={classes.sectionDescription}
        >
          This is the first release of the CuRVE Tool and there will be frequent improvements and regular updates to the site. We welcome your feedback on ways we could improve this tool in the future.
        </Typography>
        {/* <Button variant="text" className={classes.learnMore} endIcon={<ArrowForwardIcon className={classes.nextButton}/>}>LEARN MORE </Button> */}
      </Grid>
      <Grid item xs={12} lg={4} className={classes.sectionContainer}>
        <Typography
          component="div"
          variant="h6"
          className={classes.sectionTitle}
        >
          {"Methodology & Assumptions"}
        </Typography>
        <Typography
          component="div"
          variant="body2"
          className={classes.sectionDescription}
        >
          River modeling and water accounting are both difficult and involve many approximations,
          simplifications, and assumptions.  
          <br/>
          <Button 
            className={classes.downloadButton} 
            onClick={()=>{getMethodologyPDF(setDisabledDownload)}}
            disabled={disabledDownload}
          >
            Download and explore the documentation here
          </Button>
        </Typography>
        {/* <Button variant="text" className={classes.learnMore} endIcon={<ArrowForwardIcon className={classes.nextButton}/>}>LEARN MORE </Button> */}
      </Grid>
    </Grid>
  );
};

export default AboutSection;
